export const TC_CLAIMS_HEADER = 'tc-claims-header';

export const CLAIMS = {
  MANAGER: {
    VIEW_HOMEPAGE_NOTE: 'ViewHomepageNote',
  },
  CHANGE_CRLINC_THEME: 'ChangeCRLINCTheme',
  ADMINISTRATION: {
    CALL_TYPES: {
      CREATE_CALL_TYPES: 'CreateCallTypes',
      EDIT_CALL_TYPES: 'EditCallTypes',
      VIEW_CALL_TYPES: 'ViewCallTypes',
    },
    COMPANIES: {
      CREATE_COMPANIES: 'CreateCompanies',
      DELETE_COMPANIES: 'DeleteCompanies',
      EDIT_COMPANIES: 'EditCompanies',
      VIEW_COMPANIES: 'ViewCompanies',
    },
    EMAIL_GROUPS: {
      CREATE_EMAIL_GROUPS: 'CreateEmailGroups',
      DELETE_EMAIL_GROUPS: 'DeleteEmailGroups',
      EDIT_EMAIL_GROUPS: 'EditEmailGroups',
      VIEW_EMAIL_GROUPS: 'ViewEmailGroups',
    },
    JOB_ROLES: {
      CREATE_JOB_ROLES: 'CreateJobRoles',
      DELETE_JOB_ROLES: 'DeleteJobRoles',
      EDIT_JOB_ROLES: 'EditJobRoles',
      VIEW_JOB_ROLES: 'ViewJobRoles',
    },
    NOTE_TYPES: {
      CREATE_NOTE_TYPES: 'CreateNoteTypes',
      DELETE_NOTE_TYPES: 'DeleteNoteTypes',
      EDIT_NOTE_TYPES: 'EditNoteTypes',
      VIEW_NOTE_TYPES: 'ViewNoteTypes',
    },
    ROLES: {
      EDIT_ROLES: 'EditRoles',
      VIEW_ROLES: 'ViewRoles',
    },
  },
  CONTACTS: {
    CONTACTS: {
      CREATE_CONTACT: 'CreateContact',
      MARK_USERS_INACTIVE: 'MarkUsersInactive',
      VIEW_CONTACTS: 'ViewContacts',
      PII: {
        VIEW_ALL_PII: 'ViewAllPII',
        VIEW_DIRECT_REPORTS_PII: 'ViewDirectReportsPII',
        VIEW_OWN_PII: 'ViewOwnPII',
      },
    },
    CONTACT_LISTS: {
      ADD_REMOVE_DIRECT_REPORTS_CONTACT_LIST:
        'AddRemoveDirectReportsContactList',
      ADD_REMOVE_OWN_CONTACT_LIST: 'AddRemoveOwnContactList',
      ADD_REMOVE_UPDATER_CONTACT_LIST: 'AddRemoveUpdaterContactList',
      CREATE_CONTACT_LISTS: 'CreateContactLists',
      DELETE_CONTACT_LIST: 'DeleteContactList',
      EDIT_CONTACT_LISTS: 'EditContactLists',
      MEMBER_CODES: {
        ADD_MEMBER_CODE: 'AddMemberCode',
        REMOVE_MEMBER_CODE: 'RemoveMemberCode',
      },
      ROTATE_ALL_CONTACT_LISTS: 'RotateAllContactLists',
      ROTATE_DIRECT_REPORT_CONTACT_LISTS: 'RotateDirectReportContactLists',
      ROTATE_OWN_CONTACT_LISTS: 'RotateOwnContactLists',
      SCHEDULE_CONTACT_LISTS: 'ScheduleContactLists',
      SCHEDULE_DIRECT_REPORTS_CONTACT_LISTS:
        'ScheduleDirectReportsContactLists',
      SCHEDULE_OWN_CONTACT_LISTS: 'ScheduleOwnContactLists',
      VIEW_CONTACT_LISTS: 'ViewContactLists',
      VIEW_CONTACT_LIST_UPDATERS: 'ViewContactListUpdaters',
    },
    EXTERNAL_LISTS: {
      CREATE_EXTERNAL_LISTS: 'CreateExternalLists',
      DELETE_EXTERNAL_LISTS: 'DeleteExternalLists',
      EDIT_EXTERNAL_LISTS: 'EditExternalLists',
      VIEW_EXTERNAL_LISTS: 'ViewExternalLists',
    },
    PROFILES: {
      EDIT_ALL_PROFILES: 'EditAllProfiles',
      EDIT_DIRECT_REPORTS_PROFILE: 'EditDirectReportsProfile',
      EDIT_OWN_PROFILE: 'EditOwnProfile',
    },
  },
  CONTROL_ROOM: {
    CONTROLLER_NOTES: {
      CREATE_CONTROLLER_NOTES: 'CreateControllerNotes',
      DELETE_CONTROLLER_NOTES: 'DeleteControllerNotes',
      DELETE_OWN_CONTROLLER_NOTES: 'DeleteOwnControllerNotes',
      EDIT_CONTROLLER_NOTES: 'EditControllerNotes',
      EDIT_OWN_CONTROLLER_NOTES: 'EditOwnControllerNotes',
      VIEW_CONTROLLER_NOTES: 'ViewControllerNotes',
      ENTRIES: {
        ADD_CONTROLLER_NOTE_ENTRIES: 'AddControllerNoteEntries',
        DELETE_CONTROLLER_NOTE_ENTIRES: 'DeleteControllerNoteEntries',
        DELETE_OWN_CONTROLLER_NOTE_ENTRIES: 'DeleteOwnControllerNoteEntries',
        EDIT_CONTROLLER_NOTE_ENTRIES: 'EditControllerNoteEntries',
        EDIT_OWN_CONTROLLER_NOTE_ENTIRES: 'EditOwnControllerNoteEntries',
      },
    },
    CONTROL_ROOM_EVENTS: {
      ENTRIES: {
        CREATE_CONTROL_ROOM_EVENT_REVIEW_ENTRIES:
          'CreateControlRoomEventReviewEntries',
        DELETE_ALL_CONTROL_ROOM_EVENT_REVIEW_ENTRIES:
          'DeleteAllControlRoomEventReviewEntries',
        DELETE_OWN_CONTROL_ROOM_EVENT_REVIEW_ENTRIES:
          'DeleteOwnControlRoomEventReviewEntries',
        EDIT_ALL_CONTROL_ROOM_EVENT_REVIEW_ENTRIES:
          'EditAllControlRoomEventReviewEntries',
        EDIT_OWN_CONTROL_ROOM_EVENT_REVIEW_ENTRIES:
          'EditOwnControlRoomEventReviewEntries',
      },
      VIEW_CONTROL_ROOM_EVENT_REVIEW: 'ViewControlRoomEventReview',
    },
    CRM_SHIFT_TURNOVERS: {
      CREATE_GC_TURNOVERS: 'CreateGCTurnovers',
      EDIT_ALL_CRM_TURNOVER_SECTIONS: 'EditAllCRMTurnoverSections',
      EDIT_GC_RESOLVED_TURNOVERS: 'EditGCResolvedTurnovers',
      EDIT_GC_UNRESOLVED_TURNOVERS: 'EditGCUnresolvedTurnovers',
      EDIT_LOCKED_GC_TURNOVERS: 'EditLockedGCTurnovers',
      EDIT_OWN_CRM_TURNOVER_SECTIONS: 'EditOwnCRMTurnoverSections',
      VIEW_ALL_CRM_TURNOVER_DEPARTING_SECTIONS:
        'ViewAllCRMTurnoverDepartingSections',
      VIEW_ALL_CRM_TURNOVER_INCOMING_SECTIONS:
        'ViewAllCRMTurnoverIncomingSections',
      VIEW_GC_TURNOVERS: 'ViewGCTurnovers',
    },
    DAILY_OPERATING_PLANS: {
      ACKNOWLEDGE_DAILY_OPERATING_PLANS: 'AcknowledgeDailyOperatingPlans',
      ENTRIES: {
        CREATE_DAILY_OPERATING_PLAN_ENTRIES: 'CreateDailyOperatingPlanEntries',
        DELETE_ALL_DAILY_OPERATING_PLAN_ENTRIES:
          'DeleteAllDailyOperatingPlanEntries',
        DELETE_DIRECT_REPORTS_DAILY_OPERATING_PLAN_ENTRIES:
          'DeleteDirectReportsDailyOperatingPlanEntries',
        DELETE_OWN_DAILY_OPERATING_PLAN_ENTRIES:
          'DeleteOwnDailyOperatingPlanEntries',
        EDIT_ALL_DAILY_OPERATING_PLAN_ENTRIES:
          'EditAllDailyOperatingPlanEntries',
        EDIT_DIRECT_REPORTS_DAILY_OPERATING_PLAN_ENTRIES:
          'EditDirectReportsDailyOperatingPlanEntries',
        EDIT_OWN_DAILY_OPERATING_PLAN_ENTRIES:
          'EditOwnDailyOperatingPlanEntries',
      },
      VIEW_DAILY_OPERATING_PLANS: 'ViewDailyOperatingPlans',
    },
    MOC_EVENTS: {
      ACKNOWLEDGE_MOC_EVENTS: 'AcknowledgeMOCEvents',
      CATEGORIES: {
        CREATE_MOC_EVENT_CATEGORIES: 'CreateMOCEventCategories',
        DELETE_MOC_EVENT_CATEGORIES: 'DeleteMOCEventCategories',
        EDIT_MOC_EVENT_CATEGORIES: 'EditMOCEventCategories',
        VIEW_MOC_EVENT_CATEGORIES: 'ViewMOCEventCategories',
      },
      CREATE_MOC_EVENTS: 'CreateMOCEvents',
      DELETE_MOC_EVENTS: 'DeleteMOCEvents',
      EDIT_MOC_EVENTS: 'EditMOCEvents',
      VIEW_MOC_EVENTS: 'ViewMOCEvents',
      EDIT_PERMANENT_MOC_END_DATE: 'EditPermanentMOCEndDate',
    },
  },
  FIELD_OPERATIONS: {
    ALARM_LIMITS: {
      CHANGE_ALL_ALARM_LIMITS: 'ChangeAllAlarmLimits',
      CHANGE_DIRECT_REPORTS_ALARM_LIMITS: 'ChangeDirectReportsAlarmLimits',
      CHANGE_OWN_ALARM_LIMITS: 'ChangeOwnAlarmLimits',
      SEND_ALARM_LIMIT_REQUESTS: 'SendAlarmLimitRequests',
      VIEW_ALL_ALARM_LIMITS: 'ViewAllAlarmLimits',
      VIEW_DIRECT_REPORTS_ALARM_LIMITS: 'ViewDirectReportsAlarmLimits',
      VIEW_OWN_ALARM_LIMITS: 'ViewOwnAlarmLimits',
    },
    OPERATIONAL_ALERTS: {
      DELETE_OPERATIONAL_ALERT: 'DeleteOperationalAlert',
      EDIT_OPERATIONAL_ALERT: 'EditOperationalAlert',
      ENTRIES: {
        ADD_OPERATIONAL_ALERT_ENTRY: 'AddOperationalAlertEntry',
        ADD_DIRECT_REPORT_OPERATIONAL_ALERT_ENTRY:
          'AddDirectReportOperationalAlertEntry',
        ADD_OWN_OPERATIONAL_ALERT_ENTRY: 'AddOwnOperationalAlertEntry',
        DELETE_DIRECT_REPORT_OPERATIONAL_ALERT_ENTRY:
          'DeleteDirectReportOperationalAlertEntry',
        DELETE_OWN_OPERATIONAL_ALERT_ENTRY: 'DeleteOwnOperationalAlertEntry',
        EDIT_DIRECT_REPORT_OPERATIONAL_ALERT_ENTRY:
          'EditDirectReportOperationalAlertEntry',
        EDIT_OWN_OPERATIONAL_ALERT_ENTRY: 'EditOwnOperationalAlertEntry',
      },
      VIEW_OPERATIONAL_ALERT_LOGS: 'ViewOperationalAlertLogs',
    },
    PARTS_SEARCH: {
      CREATE_PARTS: 'CreateParts',
      DELETE_PARTS: 'DeleteParts',
      EDIT_PARTS: 'EditParts',
      VIEW_PARTS: 'ViewParts',
    },
    PLC_ALARM_CODES: {
      CREATE_PLC_ALARM_CODES: 'CreatePlcAlarmCodes',
      DELETE_PLC_ALARM_CODES: 'DeletePlcAlarmCodes',
      EDIT_PLC_ALARM_CODES: 'EditPlcAlarmCodes',
      VIEW_PLC_ALARM_CODES: 'ViewPlcAlarmCodes',
    },
    STATION_LOGS: {
      CREATE_STATION_LOGS: 'CreateStationLogs',
      DELETE_STATION_LOGS: 'DeleteStationLogs',
      EDIT_STATION_LOGS: 'EditStationLogs',
      VIEW_STATION_LOGS: 'ViewStationLogs',
    },
    MUSTER_LIST: {
      VIEW_MUSTER_LIST: 'ViewMusterList',
    },
  },
  LOCATIONS: {
    AREAS: {
      CREATE_AREA: 'CreateAreas',
      DELETE_AREA: 'DeleteAreas',
      EDIT_AREA: 'EditAreas',
      VIEW_AREAS: 'ViewAreas',
    },
    FACILITIES: {
      ADD_CONTACT_LIST_TO_FACILITY: 'AddContactListToFacility',
      CREATE_FACILITIES: 'CreateFacilities',
      EDIT_FACILITIES: 'EditFacilities',
      NOTEPAD_ENTRIES: {
        ADD_ALL_FACILITY_NOTEPAD_ENTRIES: 'AddAllFacilityNotepadEntries',
        ADD_DIRECT_REPORTS_FACILITY_NOTEPAD_ENTRIES:
          'AddDirectReportsFacilityNotepadEntries',
        ADD_OWN_FACILITY_NOTEPAD_ENTRIES: 'AddOwnFacilityNotepadEntries',
        ARCHIVE_ALL_FACILITY_NOTEPAD_ENTRIES:
          'ArchiveAllFacilityNotepadEntries',
        ARCHIVE_DIRECT_REPORTS_FACILITY_NOTEPAD_ENTRIES:
          'ArchiveDirectReportsFacilityNotepadEntries',
        ARCHIVE_OWN_FACILITY_NOTEPAD_ENTRIES:
          'ArchiveOwnFacilityNotepadEntries',
        DELETE_ALL_FACILITY_NOTEPAD_ENTRIES: 'DeleteAllFacilityNotepadEntries',
        DELETE_DIRECT_REPORTS_FACILITY_NOTEPAD_ENTRIES:
          'DeleteDirectReportsFacilityNotepadEntries',
        DELETE_OWN_FACILITY_NOTEPAD_ENTRIES: 'DeleteOwnFacilityNotepadEntries',
        EDIT_ALL_FACILITY_NOTEPAD_ENTRIES: 'EditAllFacilityNotepadEntries',
        EDIT_DIRECT_REPORTS_FACILITY_NOTEPAD_ENTRIES:
          'EditDirectReportsFacilityNotepadEntries',
        EDIT_OWN_FACILITY_NOTEPAD_ENTRIES: 'EditOwnFacilityNotepadEntries',
        VIEW_ALL_FACILITY_NOTEPADS: 'ViewAllFacilityNotepads',
        VIEW_DIRECT_REPORTS_FACILITY_NOTEPADS:
          'ViewDirectReportsFacilityNotepads',
        VIEW_OWN_FACILITY_NOTEPADS: 'ViewOwnFacilityNotepads',
      },
      REMOVE_CONTACT_LIST_FROM_FACILITY: 'RemoveContactListFromFacility',
      SYNC_SAP_FOR_FACILITY: 'SyncSapForFacility',
      VIEW_FACILITIES: 'ViewFacilities',
    },
    LOCATIONS: {
      CREATE_LOCATIONS: 'CreateLocations',
      EDIT_LOCATIONS: 'EditLocations',
      VIEW_LOCATIONS: 'ViewLocations',
    },
    REGIONS: {
      CREATE_REGIONS: 'CreateRegions',
      DELETE_REGIONS: 'DeleteRegions',
      EDIT_REGIONS: 'EditRegions',
      VIEW_REGIONS: 'ViewRegions',
    },
  },
  MAP: {
    VIEW_FIELD_VISION: 'ViewFieldVision',
    VIEW_GIS_MAP: 'ViewGISMap',
  },
  COMMERCIAL_SERVICES: {
    COMMERCIAL_CONTACTS: {
      CREATE_COMMERCIAL_CONTACTS: 'CreateCommercialContacts',
      DELETE_COMMERCIAL_CONTACTS: 'DeleteCommercialContacts',
      EDIT_COMMERCIAL_CONTACTS: 'EditCommercialContacts',
      VIEW_COMMERCIAL_CONTACTS: 'ViewCommercialContacts',
    },
  },
  MONITORING_CENTER: {
    MC_SHIFT_TURNOVERS: {
      CREATE_MC_TURNOVERS: 'CreateMCTurnovers',
      EDIT_ALL_MC_TURNOVER_SECTIONS: 'EditAllMCTurnoverSections',
      EDIT_LOCKED_MC_TURNOVERS: 'EditLockedMCTurnovers',
      EDIT_MC_RESOLVED_TURNOVERS: 'EditMCResolvedTurnovers',
      EDIT_MC_UNRESOLVED_TURNOVERS: 'EditMCUnresolvedTurnovers',
      EDIT_OWN_MC_TURNOVER_SECTIONS: 'EditOwnMCTurnoverSections',
      VIEW_ALL_MC_TURNOVER_DEPARTING_SECTIONS:
        'ViewAllMCTurnoverDepartingSections',
      VIEW_ALL_MC_TURNOVER_INCOMING_SECTIONS:
        'ViewAllMCTurnoverIncomingSections',
      VIEW_MC_TURNOVERS: 'ViewMCTurnovers',
    },
    MON_LOGS: {
      ADD_MON_LOG_ALARMS: 'AddMonLogAlarms',
      COMPLETE_MON_LOG_REVIEWS: 'CompleteMonLogReviews',
      CREATE_MON_LOGS: 'CreateMonLogs',
      DELETE_MON_LOGS: 'DeleteMonLogs',
      EDIT_MON_LOGS: 'EditMonLogs',
      EMERGENCY_LOCATE_LOGS: {
        CREATE_EMERGENCY_LOCATE_LOGS: 'CreateEmergencyLocateLogs',
        EDIT_EMERGENCY_LOCATE_LOGS: 'EditEmergencyLocateLogs',
      },
      VIEW_MON_LOGS: 'ViewMonLogs',
    },
  },
  REPORTING: {
    VIEW_OUTAGE_REPORT: 'ViewOutageReport',
  },
};
